
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/service/seller/reRequest",
      function () {
        return require("private-next-pages/service/seller/reRequest/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/service/seller/reRequest"])
      });
    }
  